import { createSlice } from "@reduxjs/toolkit";

const actionData:any = {};

const userActionDataSlice = createSlice({
    name:'actionData',
    initialState:actionData,
    reducers:{
        setActionData:(state,action:any) => {
           return state={...action.payload}
        }
    }
});

export const { setActionData } = userActionDataSlice.actions;
export { userActionDataSlice as UserActionDataSlice };
export {actionData};